import { Dropdown } from "primereact/dropdown";

import { OrderPeriodFilterWrapper } from "./styles.ts";

interface IOrderPeriodFilter {
	count: number;
	filterOptions: any;
	activeItem: any;
	handleChangeCallback: any;
}

export const OrderPeriodFilter: React.FC<IOrderPeriodFilter> = ({
	count,
	filterOptions,
	activeItem,
	handleChangeCallback,
}) => {
	return (
		<OrderPeriodFilterWrapper>
			{count > 0 ? (
				<span>
					<strong>
						{count} pedido{count > 1 && "s"}
					</strong>{" "}
					realizado{count > 1 && "s"}
				</span>
			) : (
				<span>Nenhum pedido realizado</span>
			)}

			<Dropdown
				options={filterOptions}
				optionLabel="label"
				value={activeItem}
				onChange={handleChangeCallback}
			></Dropdown>
		</OrderPeriodFilterWrapper>
	);
};
